import React from 'react';
import {Col} from 'antd';
import DocumentMeta from 'react-document-meta';
import {studentsMeta} from '../constants/meta';
import {CusImage, Section, PageHeader} from '../common'
import ImageSrc from '../img/st.jpg';

const Students = () => {
  return (
    <DocumentMeta {...studentsMeta}>
      <PageHeader title="Ученици" />
      <Section>
        <Col md={12}>
          <h2>Математика</h2>
          <p>Предлагаме квалифицирана помощ за <strong>решаване на задачи по математика</strong> за всички ученици от първи до дванадесети клас.</p>

          <h2>Excel</h2>
          <p>Извършване на разнообразни <strong>изчисления в Excel</strong>.</p>

          <h2>Power Point</h2>
          <p>Изготвяне на индивидуални <strong>презентации</strong>.</p>
        </Col>
        <Col style={{margin: "auto"}} xs={20} md={12}>
          <CusImage src={ImageSrc} alt="Решаване на задачи" />
        </Col>
      </Section>
    </DocumentMeta>
  );
};

export default Students;